import { z } from "zod";
import {
  DEFAULT_GENERATIVE_FILL_MODEL,
  DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_CREATIVITY_STRENGTH_PRESETS,
  GENERATIVE_FILL_MODELS,
} from "../../../Board/Workspaces/EditWorkspace/Tools/EditAsset/GenerativeFill/constants.ts";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

export const DEFAULT_GENERATIVE_FILL_GUIDANCE_SCALE = 0.5;
const DEFAULT_DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_CREATIVITY_STRENGTH_PRESET =
  "MEDIUM";

const zGenerativeFillSettings = z.object({
  prompt: z.string().default(""),
  num_generations: z.number().default(4),
  guidance_scale: z.number().default(DEFAULT_GENERATIVE_FILL_GUIDANCE_SCALE),
  model_used: z
    .enum(GENERATIVE_FILL_MODELS)
    .default(DEFAULT_GENERATIVE_FILL_MODEL),
  differential_diffusion_settings: z
    .object({
      prompt_strength: z.number().nullable(),
      creativity_strength_preset: z.enum(
        DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_CREATIVITY_STRENGTH_PRESETS,
      ),
    })
    .default({
      creativity_strength_preset:
        DEFAULT_DIFFERENTIAL_DIFFUSION_GENERATIVE_FILL_CREATIVITY_STRENGTH_PRESET,
      prompt_strength: null,
    }),
});

export const generativeFillSettingsStorage = settingsStorageFactory(
  "generative-fill-settings",
  2,
  zGenerativeFillSettings,
  () =>
    zGenerativeFillSettings
      .omit({ prompt: true, num_generations: true })
      .parse({}),
);
